import React, { useEffect, useState, useCallback } from 'react';
import { Ralert } from '../pages/common/vhelper/Normarodallalert';

const GlobalAlertListener = () => {
	const [visible, setVisible] = useState(false);
	const [message, setMessage] = useState('');
	const [type, setType] = useState('');

	const handleClose = useCallback(() => setVisible(false), []);

	useEffect(() => {
		const handler = (e) => {
			const { message: msg, type: t } = e.detail || {};
			setMessage(msg || 'Unexpected error');
			setType(t || 'Error');
			setVisible(true);
		};
		window.addEventListener('global-alert', handler);
		return () => window.removeEventListener('global-alert', handler);
	}, []);

	return (
		<Ralert
			msgloadalert={
				typeof message === 'string'
					? message.split('\n').map((line, idx) => (
							<React.Fragment key={idx}>
								{line}
								{idx < message.split('\n').length - 1 && <br />}
							</React.Fragment>
					  ))
					: message
			}
			msgtypeloadalert={type}
			loadalert={visible}
			closemodel={handleClose}
		/>
	);
};

export default GlobalAlertListener;
